import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export let ERecallSource;
(function (ERecallSource) {
  ERecallSource["Upload"] = "upload";
  ERecallSource["Ui"] = "ui";
  ERecallSource["Integrator"] = "integrator";
})(ERecallSource || (ERecallSource = {}));
export let ERecallStatus;
(function (ERecallStatus) {
  ERecallStatus["Pending"] = "pending";
  ERecallStatus["Active"] = "active";
  ERecallStatus["Scheduled"] = "scheduled";
})(ERecallStatus || (ERecallStatus = {}));
export const fieldsRecall = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  attempt: {
    type: 'Number'
  },
  date: {
    type: 'Date'
  },
  externalId: {
    type: 'Option',
    values: EExternalSource
  },
  externalRawSource: {
    type: 'Unknown'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  lastAttemptSentAt: {
    type: 'Date'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  scheduledAt: {
    type: 'Date'
  },
  source: {
    type: 'Option',
    values: ERecallSource
  },
  status: {
    type: 'Option',
    values: ERecallStatus
  },
  type: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  upload: {
    type: 'ID',
    ref: EModel.Upload
  }
});